import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormHelperText,
  InputLabel,
  Input,
  Button,
  Grid,
  CircularProgress
} from '@mui/material';
import { Save as SaveIcon, Cancel as CancelIcon } from '@mui/icons-material';

const ServicoFormDialog = ({
  isOpen,
  onClose,
  isEditing,
  currentServico,
  formErrors,
  submitting,
  handleInputChange,
  handleSubmit
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxWidth: 'sm',
          width: '100%'
        }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        {isEditing ? 'Editar Serviço' : 'Adicionar Novo Serviço'}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3} sx={{ mt: 0 }}>
          <Grid item xs={12}>
            <FormControl fullWidth error={!!formErrors.nome} sx={{ mb: 1 }}>
              <InputLabel htmlFor="nome">Nome do Serviço</InputLabel>
              <Input
                id="nome"
                name="nome"
                value={currentServico.nome}
                onChange={handleInputChange}
                autoFocus
              />
              {formErrors.nome && (
                <FormHelperText>{formErrors.nome}</FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth error={!!formErrors.abreviacao} sx={{ mb: 1 }}>
              <InputLabel htmlFor="abreviacao">Abreviação</InputLabel>
              <Input
                id="abreviacao"
                name="abreviacao"
                value={currentServico.abreviacao}
                onChange={handleInputChange}
                inputProps={{ maxLength: 3 }}
              />
              <FormHelperText>
                {formErrors.abreviacao || 'Máximo 3 caracteres. Será usada na geração de senhas.'}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel htmlFor="descricao">Descrição</InputLabel>
              <Input
                id="descricao"
                name="descricao"
                value={currentServico.descricao}
                onChange={handleInputChange}
                multiline
                rows={3}
              />
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          color="inherit"
          disabled={submitting}
          startIcon={<CancelIcon />}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={submitting}
          startIcon={submitting ? <CircularProgress size={16} /> : <SaveIcon />}
        >
          {submitting ? 'Salvando...' : 'Salvar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServicoFormDialog; 